<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="apprentice-simple-card">
                    <label>{{ $t('assignment.youtube_link') }}</label>
                    <b-form-input
                        v-model="slideIn.value"
                        :placeholder="$t('assignment.set_youtube_link')">
                    </b-form-input>
                    <design-2021-apprentice-video-link-player-component
                        v-if="slideIn.value"
                        :options="playerOptions"
                        :src="slideIn.value">
                    </design-2021-apprentice-video-link-player-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'design-2021-presentation-edit-video-type-component',
    props: {
        slideIn: Object,
    },
    data() {
        return {
            playerOptions: {
                responsive: true,
                autoplay: false,
                controls: true,
            },
        };
    },
};
</script>

<style scoped lang="scss"></style>
